import { useStore } from 'vuex'
import supportTypeEnum from '../supportTypeEnum'

export default function () {
    const store = useStore()
    const donationFor = store.state.donation.donationFor
    return donationFor !== supportTypeEnum.NONE
}
